export const mockUserData = {
    authType: 'registered',
    email: 'test.user@email.com',
    firstName: 'Jane',
    lastName: 'Doe',
    login: 'test.user@email.com',
    customerType: 'registered',
    isRegistered: true,
    isGuest: false
}
